import React from "react";
import TooltipMessage from "./TooltipMessage.js";
import classNames from "classnames";
import injectSheet from "react-jss";
import styles from "./styles";
import PropTypes from "prop-types";

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.body = document.getElementsByTagName("body")[0];
    this.state = {
      isOpen: false,
      tooltipRect: {},
      messageRect: {},
      bodyWidth: this.body.clientWidth
    };
  }

  static propTypes = {
    symbol: PropTypes.any,
    toggleOnHover: PropTypes.bool,
    component: PropTypes.func,
    direction: PropTypes.oneOf(["left", "right"])
  };

  static defaultProps = {
    symbol: "i"
  };

  static left = "left";
  static right = "right";

  getRectPositions = () => {
    const tooltipRect = this.tooltip.getBoundingClientRect();
    const messageRect = this.message.getBoundingClientRect();
    const scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
    const bodyRect = this.body.getBoundingClientRect();

    this.setState({
      tooltipRect,
      messageRect,
      bodyWidth: bodyRect.width,
      offsetTop: scrollY + tooltipRect.top
    });
  };

  handleOpen = () => {
    window.addEventListener("resize", this.getRectPositions);
    this.getRectPositions();
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    window.removeEventListener("resize", this.getRectPositions);
    this.setState({ isOpen: false });
  };

  render() {
    const {
      children,
      classes,
      symbol,
      component,
      toggleOnHover,
      direction,
      ...other
    } = this.props;
    const { isOpen } = this.state;
    const Component = component;

    return (
      <div className={classes.wrapper}>
        <div
          className={classes.tooltip}
          onFocus={toggleOnHover ? null : this.handleOpen}
          onBlur={toggleOnHover ? null : this.handleClose}
          onMouseEnter={toggleOnHover ? this.handleOpen : null}
          onMouseLeave={toggleOnHover ? this.handleClose : null}
          ref={tooltip => (this.tooltip = tooltip)}
          tabIndex={0}
          {...other}
        >
          {component ? (
            <Component />
          ) : (
            <span
              className={classNames(classes.symbol, {
                [classes.open]: isOpen
              })}
            >
              {symbol}
            </span>
          )}
        </div>

        {
          <TooltipMessage
            isOpen={isOpen}
            tooltipRect={this.state.tooltipRect}
            messageRect={this.state.messageRect}
            offsetTop={this.state.offsetTop}
            bodyWidth={this.state.bodyWidth}
            toggleOnHover={toggleOnHover}
            direction={direction}
          >
            <div ref={message => (this.message = message)}>{children}</div>
          </TooltipMessage>
        }
      </div>
    );
  }
}

export default injectSheet(styles, { inject: ["classes"] })(Tooltip);
